/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';
import React from 'react';

import { Grid2 } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';

function HomeTour({ driverObj, tourCompletion, setDialogOpen, setTourOn }) {
  const handleClose = () => setDialogOpen(false);

  const startTour = () => {
    driverObj.drive(tourCompletion.home.step);
    setTourOn(true);
    handleClose();
  };

  return (
    <Dialog
      sx={{ width: '80%', margin: 'auto' }}
      open
      onClose={handleClose}
      PaperProps={{ style: { maxWidth: 'none' } }}
    >
      <Box style={{ padding: '30px' }}>
        <DialogTitle style={{ marginBottom: '15px' }}>
          <Grid2 container direction="column" alignItems="center">
            <Grid2 item style={{ marginBottom: '8px' }}>
              <Typography
                component="h3"
                style={{
                  fontFamily: 'Montserrat',
                  fontWeight: '600',
                  fontSize: '1.2rem',
                }}
              >
                Bem vindo(a) à
              </Typography>
            </Grid2>
            <Grid2 item>
              <Typography
                component="h3"
                style={{
                  fontFamily: 'Montserrat',
                  fontWeight: '800',
                  fontSize: '2.5rem',
                }}
              >
                Home
              </Typography>
            </Grid2>
          </Grid2>
        </DialogTitle>
        <Typography
          component="p"
          style={{ fontFamily: 'Montserrat', fontSize: '1rem' }}
        >
          Esta é a sua tela inicial, ou seja, a primeira página que você verá ao
          fazer login no sistema SIOON.
        </Typography>
        <Typography
          component="p"
          style={{ fontFamily: 'Montserrat', fontSize: '1rem' }}
        >
          Nela, você encontrará informações essenciais para auxiliá-lo na
          administração do sistema. A seguir, apresentaremos cada seção em
          detalhes.
        </Typography>
        <Grid2 container justifyContent="center">
          <Grid2 item style={{ margin: '25px 0 15px 0' }}>
            <Button
              variant="contained"
              color="primary"
              style={{ fontSize: '1.2rem', width: '12em' }}
              onClick={startTour}
            >
              Vamos Lá!
            </Button>
          </Grid2>
        </Grid2>
      </Box>
    </Dialog>
  );
}

HomeTour.propTypes = {
  driverObj: PropTypes.object.isRequired,
  tourCompletion: PropTypes.object.isRequired,
  setDialogOpen: PropTypes.func.isRequired,
};

export default HomeTour;
